import React from "react"
import { Grid2 } from "@mui/material"

import { TextFieldProps } from "@/components/TextField/protocols"
import { Input } from "@/components/Input"

export const TextField = ({
	label,
	subLabel,
	errorText,
	isOptional,
	id,
	characterCount,
	...props
}: TextFieldProps) => {
	return (
		<Grid2 container direction="column" key={id} spacing={2} width="100%">
			<Input.Label
				label={label}
				subLabel={subLabel}
				isOptional={isOptional}
			/>
			<Grid2 container direction="column" spacing={1} width="100%">
				<Input.Field
					{...props}
					showInputUnderline={false}
					errorText={errorText}
					characterCount={characterCount}
				/>
				<Input.ErrorText errorText={errorText} />
			</Grid2>
		</Grid2>
	)
}
